import { Group, Stack } from '@mantine/core';
import { Icon, Text } from '@repo/foundations';
import { isEmpty } from 'lodash-es';
import { useMemo } from 'react';
import type { IResourceContentProps } from '../../types';

export function SchemaTablesDroppedContent({
	selected,
}: IResourceContentProps) {
	const changes = useMemo(() => {
		const meta = selected.metadata as Record<string, any> | null | undefined;
		return meta?.changes ?? {};
	}, [selected.metadata]);

	const droppedTables = Array.isArray(changes.deleted_tables)
		? (changes.deleted_tables as string[])
		: [];

	if (isEmpty(droppedTables)) {
		return null;
	}

	return (
		<Stack spacing="xl">
			<Text size="sm" color="text/secondary/default">
				Dropped tables
			</Text>
			<Stack spacing={4}>
				{droppedTables.map((table) => (
					<Group key={table} spacing={4} align="center">
						<Icon
							name="minus"
							color="icon/critical/default"
							style={{ flexShrink: 0 }}
						/>
						<Text size="sm">{table}</Text>
					</Group>
				))}
			</Stack>
		</Stack>
	);
}
